import { render, staticRenderFns } from "./bookingJoinPage.vue?vue&type=template&id=449b21e4&scoped=true"
import script from "./bookingJoinPage.vue?vue&type=script&lang=ts"
export * from "./bookingJoinPage.vue?vue&type=script&lang=ts"
import style0 from "./bookingJoinPage.vue?vue&type=style&index=0&id=449b21e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449b21e4",
  null
  
)

export default component.exports